var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('h2',[_vm._v("欢迎 "+_vm._s(_vm.user.name)+" 回来...")])])}
var staticRenderFns = []

export { render, staticRenderFns }